export const ZIPCODES_INSCOPE = [
  // North Side
  "60645", "60626", "60660", "60640", "60625", "60630", "60634", "60641", "60618",
  "60613", "60657", "60614", "60647", "60651", "60622", "60642",
  // Downtown/Central
  "60610", "60611", "60654", "60601", "60602", "60603", "60604", "60605", "60606",
  "60607", "60616", "60661",
  // South Side
  "60608", "60609", "60612", "60615", "60616", "60617", "60619", "60620", "60621",
  "60623", "60624", "60628", "60629", "60632", "60633", "60636", "60637", "60638",
  "60643", "60649", "60652", "60653", "60655", "60659",
  // Far North/Northwest
  "60631", "60646", "60656", "60666", "60678", "60680", "60681", "60682", "60684",
  // Special location
  "ilovealina"
];

// Lazy-loaded zipcode coordinates cache
let zipcodeDataCache = null;
let loadingPromise = null;

/**
 * Lazily loads zipcode coordinate data only when needed.
 * Returns cached data on subsequent calls.
 */
export const getZipcodeCoordinates = async (zipcode) => {
  // Return from cache if available
  if (zipcodeDataCache) {
    const data = zipcodeDataCache[zipcode];
    return data ? { latitude: data.lat, longitude: data.lon, zipCode: zipcode } : null;
  }

  // If already loading, wait for it
  if (loadingPromise) {
    await loadingPromise;
    const data = zipcodeDataCache[zipcode];
    return data ? { latitude: data.lat, longitude: data.lon, zipCode: zipcode } : null;
  }

  // Fetch the data
  loadingPromise = fetch('/data/zipcodes.json')
    .then(res => res.json())
    .then(data => {
      zipcodeDataCache = data;
      loadingPromise = null;
      return data;
    })
    .catch(err => {
      console.error('Failed to load zipcode data:', err);
      loadingPromise = null;
      return null;
    });

  await loadingPromise;

  if (zipcodeDataCache) {
    const data = zipcodeDataCache[zipcode];
    return data ? { latitude: data.lat, longitude: data.lon, zipCode: zipcode } : null;
  }

  return null;
};
